(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nav-mobile"] && !Shopify.designMode) return;
  try {
    const cartIconMobile = document.querySelector('#cart-icon-mobile');
  cartIconMobile.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#cart-icon').click();
  });

  (function () {
    const tabMode = document.documentElement.dataset.tab_mode;
    if (!tabMode || tabMode === 'retail') return;
    const homeLink = document.querySelector('.nav-mobile .home__link');
    const wholesaleTabLink = document.getElementById('wholesale-tab');
    const countdownTabLink = document.getElementById('countdown-tab');

    if (!homeLink || !wholesaleTabLink || !countdownTabLink) return;

    if (tabMode === 'wholesale') {
      homeLink.href = wholesaleTabLink.href;
    } else if (tabMode === 'countdown') {
      homeLink.href = countdownTabLink.href;
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
